import React from 'react'
import {createRoot} from 'react-dom/client'
import App from './components/App'
import AppErrorBoundary from './components/AppErrorBoundary'
import {Provider} from 'react-redux'
import {store} from './store/store'
import {HashRouter} from 'react-router-dom'
import './index.css'
import './types/asset-types'

const container = document.getElementById('appRoot')
const root = createRoot(container!)
root.render(
  <AppErrorBoundary>
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  </AppErrorBoundary>
)
